import { createSelector } from 'reselect';

import { getRoot } from 'modules/notifications/selectors';
import { getNotificationsByIds } from 'modules/notifications/selectors/data/byId';
import { getState as getParent } from 'modules/notifications/selectors/ui/dropdown';

const getState = createSelector(getParent, ({ ids } = {}) => ids ?? []);

/** @returns {Array<string>} */
export const getNotificationsIds = getState;

/** @returns {Array<import('modules/notifications/types').Notification>} */
export const getNotifications = createSelector(getRoot, getState, getNotificationsByIds);
